import {
  Box,
  Button,
  Center,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  IconButton,
  Image,
  Stack,
  Tooltip,
  useColorMode,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from "react-icons/ai";
import { BsMoon, BsSun } from "react-icons/bs";
import { MdOutlineApps } from "react-icons/md";
import { HiMenu } from "react-icons/hi";
import { useSelector } from "react-redux";
import store from "../redux/store";
import { fullSliderwidth } from "../redux/slice/otherSlice";
import Sidebar from "./Sidebar";
import CustomPopup from "./CustomPopup";
import { useNavigate } from "react-router-dom";

const DIGI_ONLY_MODE = true;

const Header = React.memo(() => {
  const { sidebar_width } = useSelector((state) => state.digiOther);
  const { colorMode, toggleColorMode } = useColorMode();

  const headerBg  = useColorModeValue("white", "gray.900");
  const borderClr = useColorModeValue("#88888822", "whiteAlpha.100");
  const logoBg    = useColorModeValue("#727b82", "gray.700");
  const iconColor = useColorModeValue("gray.600", "gray.300");
  const btnColor  = useColorModeValue("gray.700", "gray.200");

  const { isOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isLOpen,
    onClose: onLClose,
    onOpen: onLOpen,
  } = useDisclosure();
  const navigate = useNavigate();

  const DarkToggle = () => (
    <Tooltip label={colorMode === "dark" ? "Light mode" : "Dark mode"} hasArrow>
      <IconButton
        aria-label="Toggle color mode"
        icon={colorMode === "dark" ? <BsSun size={17} /> : <BsMoon size={16} />}
        onClick={toggleColorMode}
        variant="ghost"
        size="sm"
        color={iconColor}
      />
    </Tooltip>
  );

  return (
    <Flex h="full" w="full" bg={headerBg} borderBottom={`1px solid ${borderClr}`}>
      {/* ── Logo (desktop only) ── */}
      <Center
        w="13rem"
        minW="13rem"
        borderRight={`1px solid ${borderClr}`}
        display={["none", "none", "none", "flex"]}
      >
        <Image
          src="/logo.png"
          h="12"
          borderRadius={3}
          p={1}
          w="10rem"
          bg={logoBg}
          alt="LOGO"
        />
      </Center>

      {/* ── Mobile bar ── */}
      <Flex
        display={["flex", "flex", "flex", "none"]}
        align="center"
        px={3}
        w="full"
        justify="space-between"
      >
        <HiMenu
          size={24}
          cursor="pointer"
          color={iconColor}
          onClick={onToggle}
        />

        <Flex align="center" gap={1}>
          <DarkToggle />
          {!DIGI_ONLY_MODE && (
            <Button
              variant="ghost"
              size="sm"
              leftIcon={<MdOutlineApps size={16} />}
              onClick={() => navigate("/modules")}
              color={btnColor}
              fontWeight="medium"
            >
              Workspace
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={onLOpen}
            color="red.400"
            fontWeight="medium"
          >
            Log Out
          </Button>
        </Flex>
      </Flex>

      {/* ── Desktop bar ── */}
      <Flex
        align="center"
        px={4}
        w="full"
        justify="space-between"
        display={["none", "none", "none", "flex"]}
      >
        {/* Left: sidebar toggle */}
        <Box color={iconColor}>
          {sidebar_width ? (
            <AiOutlineMenuFold
              size={22}
              cursor="pointer"
              onClick={() => store.dispatch(fullSliderwidth())}
            />
          ) : (
            <AiOutlineMenuUnfold
              size={22}
              cursor="pointer"
              onClick={() => store.dispatch(fullSliderwidth())}
            />
          )}
        </Box>

        {/* Right: actions */}
        <Flex align="center" gap={2}>
          <DarkToggle />
          {!DIGI_ONLY_MODE && (
            <Button
              variant="ghost"
              size="sm"
              leftIcon={<MdOutlineApps size={16} />}
              onClick={() => navigate("/modules")}
              color={btnColor}
              fontWeight="medium"
            >
              Workspace
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={onLOpen}
            color="red.400"
            fontWeight="medium"
          >
            Log Out
          </Button>
        </Flex>
      </Flex>

      {/* ── Mobile drawer ── */}
      <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="xs">
        <DrawerOverlay />
        <DrawerContent
          onClick={onClose}
          maxW="52"
          bg={headerBg}
          borderRight={`1px solid ${borderClr}`}
        >
          <Sidebar />
        </DrawerContent>
      </Drawer>

      {/* ── Logout confirm popup ── */}
      <CustomPopup
        isOpen={isLOpen}
        onClose={onLClose}
        mess="Are you sure? You want to log out"
        title="Log Out"
        b_name="Log Out"
        onClick={() => {
          localStorage.removeItem("userId");
          onLClose();
          navigate("/login");
        }}
      />
    </Flex>
  );
});

export default Header;
